<template>
	<div>
		<el-form :inline="true">
			<el-form-item label="下单时间：" label-width="100">
				<el-date-picker v-model="tTime" type="daterange" range-separator="至" start-placeholder="开始日期"
					end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd HH:mm:ss"
					:default-time="['00:00:00', '23:59:59']"></el-date-picker>
			</el-form-item>
			<el-form-item label="订单号">
				<el-input v-model="searchForm.orderCode" placeholder="订单号" clearable></el-input>
			</el-form-item>
			<el-form-item label="订单状态" label-width="100">
				<el-select v-model="searchForm.orderType" clearable placeholder="选择订单状态">
					<el-option label="待发货" value="1"></el-option>
					<el-option label="待收货" value="2"></el-option>
					<el-option label="已完成" value="3"></el-option>
					<el-option label="线下订单" value="4"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="用户名称">
				<el-input v-model="searchForm.name" placeholder="用户名称" clearable></el-input>
			</el-form-item>

			<el-form-item>
				<el-button @click="getsch" type="success">搜索</el-button>
				<el-button @click="getaglin" type="success">重置</el-button>
				<el-button icon="plus" @click="getshows(1)" type="primary">订单导出</el-button>
				<el-button icon="plus" @click="getshows(2)" type="primary">详情导出</el-button>
			</el-form-item>
		</el-form>
		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" border stripe
			@selection-change="handleSelectionChange" element-loading-text="导出中..."
			element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
			v-loading="loading">
			<el-table-column label="用户名" align="center" prop="createUserName" width="200"></el-table-column>
			<el-table-column label="门店/收货人" align="center" prop="name" width="200"></el-table-column>

			<!-- <el-table-column label="自提地址" align="center" prop="deliveryMethod" width="200">
				<template slot-scope="scope">
					{{ scope.row.storeAddress }}
				</template>
			</el-table-column> -->
			<el-table-column label="送货地址" align="center" prop="deliveryMethod" width="200">
				<template slot-scope="scope">
					{{scope.row.province}}{{scope.row.city}}{{scope.row.county}}{{scope.row.address}}
				</template>
			</el-table-column>
			<el-table-column label="订单号" align="center" prop="orderCode" width="240"></el-table-column>
			<el-table-column label="物流单号" align="center" prop="logisticsNumber" width="240"></el-table-column>
			<el-table-column label="下单时间" align="center" prop="payTime" width="200"></el-table-column>
			<el-table-column label="实付金额" align="center" prop="realPayment" width="120"></el-table-column>
			<!-- <el-table-column label="配送方式" align="center" prop="deliveryMethod">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.deliveryMethod == 1"      type="success">自提</el-tag>
					<el-tag size="small" v-else-if="scope.row.deliveryMethod == 2" type="success">货拉拉</el-tag>
					<el-tag size="small" v-else-if="scope.row.deliveryMethod == 3" type="success">物流</el-tag>
				</template>
			</el-table-column> -->
			<el-table-column label="订单状态" align="center" prop="orderState" width="120">
				<template slot-scope="scope">
					<el-tag size="small" v-if="scope.row.orderType == 0" type="info">线下待支付</el-tag>
					<el-tag size="small" v-else-if="scope.row.orderType == 1" type="info">待发货</el-tag>
					<el-tag size="small" v-else-if="scope.row.orderType == 2" type="info">待收货</el-tag>
					<el-tag size="small" v-else-if="scope.row.orderType == 3" type="success">已完成</el-tag>
					<el-tag size="small" v-else-if="scope.row.orderType == 4" type="info">退款中</el-tag>
					<el-tag size="small" v-else-if="scope.row.orderType == 5" type="success">已退款</el-tag>
					<el-tag size="small" v-else-if="scope.row.orderType == 6" type="success">拒绝退款</el-tag>
					<el-tag size="small" v-else-if="scope.row.orderType == 7" type="success">取消订单</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="icon" align="center" width="300" fixed="right" label="操作">
				<template slot-scope="scope">
					<el-button type="primary" plain @click="getInfo(scope.row.orderCode)"> 订单详情 </el-button>
					<el-button type="success" plain @click="addsend(scope.row.orderCode)"
						v-if="scope.row.orderType == 1 && scope.row.deliveryMethod == 3">发货</el-button>
					<el-button type="success" plain @click="refsend(scope.row.orderCode)"
						v-if="scope.row.orderType == 1 && scope.row.deliveryMethod == 3">退款</el-button>
					<el-button type="success" plain @click="addok(scope.row.orderCode)"
						v-if="scope.row.orderType == 1 && scope.row.deliveryMethod == 1">确认自提</el-button>
					<el-button type="success" plain @click="addok(scope.row.orderCode)"
						v-if="scope.row.orderType == 1 && scope.row.deliveryMethod == 2">确认发货</el-button>
					<el-popconfirm title="确定线下已完成支付？" v-if="scope.row.orderType == 0"
						@confirm="xinpay(scope.row.orderCode)"> <el-button type="success" slot="reference"> 线下确认支付
						</el-button>
					</el-popconfirm>

				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total"></el-pagination>
		<BillDetails ref="BillDetails" v-if="BillDetailsvisible" @refreshDataList="getBill"></BillDetails>
		<el-dialog title="填写物流单号" :visible.sync="dialogVisible" width="600px" append-to-body :close-on-click-modal="false" class="">

			<el-form :inline="true">
				<el-radio v-model="pickupNum" label="2">物流</el-radio>
				<el-radio v-model="pickupNum" label="1">用户自提</el-radio>

			</el-form>
			<div style="height: 20px;">
				
			</div>
			<el-form :inline="true" v-if="pickupNum=='2'">
				<div class="flexjcen">
					<el-form-item label="物流单号">
						<el-input v-model="logisticsTrackingNumber" placeholder="请输入物流单号" clearable></el-input>
					</el-form-item>
				</div>
			</el-form>
			<div style="height: 15px;"></div>
			<div class="flexjcen">
				<div></div>
				<el-button @click="sures" :loading="flag" type="success">确认</el-button>
			</div>

		</el-dialog>
		<el-dialog title="导出" :visible.sync="showTime" width="490px" append-to-body :close-on-click-modal="false"
			class="">
			<el-form :inline="true">
				<el-form-item label="订单时间：" label-width="100">
					<el-date-picker v-model="outTime" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd HH:mm:ss"
						:default-time="['00:00:00', '23:59:59']"></el-date-picker>
				</el-form-item>
			</el-form>
			<div style="height: 15px;"></div>
			<div class="flexjcen">
				<div></div>
				<el-button @click="getdwon" type="success">确认导出</el-button>
			</div>
		</el-dialog>

		<el-dialog title="选择商品" :visible.sync="showbtn" width="1000px" append-to-body :close-on-click-modal="false"
			class="dialogClass">
			<div class="">
				<div style="margin: 15px 0;"></div>
				<!-- <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange"> -->
				<div class="" v-for="(item, index) in shoplist" :key="index">
					<div class="flexcen">
						<!-- <img class="crilebule" v-if="item.checked" @click="item.checked=false" src="https://xcx.nongheyouxuan.com/images/okright.png"  />
							<div class="crile" v-else @click="item.checked=true"></div> -->
						<el-checkbox v-model="item.checked" @change="handleChecked"
							style="padding: 10px 10px 10px 10px;" border size="30"></el-checkbox>
						<img class="bgimg" :src="item.storeGoodsCover" alt="" />
						<div class="">
							<div class="">
								{{ item.storeGoodWeight }}丨{{ item.storeGoodsName }}
							</div>
							<div class="namediscount">
								{{ item.discountExplain }}
							</div>
							<div class="" style="color:red;">
								￥{{ item.money }}
							</div>
						</div>
					</div>
				</div>
				<!-- </el-checkbox-group> -->
			</div>
			<div style="height: 40px;"></div>
			<div class="flexjcen">
				<el-checkbox v-if="shoplist.length > 0" v-model="checkAll"
					@change="handleCheckAllChange">全选</el-checkbox>
				<el-button @click="geton" type="success">确认</el-button>
			</div>

		</el-dialog>

	</div>
</template>
<script>
	import axios from 'axios'

	import ExportJsonExcel from 'js-export-excel'
	import ty from '../../utils/ty'
	import BillDetails from './BillDetails'
	export default {
		name: 'Bill',
		components: {
			BillDetails,
		},
		data() {
			return {
				checkedCities: '',
				searchForm: {
					phone: '',
					endTime: "",
					orderType: '',
					type: 0,
					name: "",
					orderCode: "",
					startTime: "",
				},
				dialogVisible: false,
				checkAll: false,
				delBtlStatu: true,
				tableData: [],
				multipleSelection: [],
				total: 0,
				size: 10,
				current: 1,
				BillDetailsvisible: false,
				//url:ty.apiurl,
				billList: [],
				logistics: "",
				id: '',
				tTime: [],
				dataList: [],
				pagedwon: 0,
				loading: false,
				showbtn: false,
				logisticsTrackingNumber: '',
				isIndeterminate: true,
				inshop: '',
				shoplist: [],
				chooid: null,
				//发货加载按钮
				flag: false,
				showTime: false,
				outTime: [],
				stop: false,
				outListId: "",
				pickupNum: '2'
			}
		},
		created() {
			this.getBill()
		},
		methods: {
			xinpay(e) {

				this.$axios
					.post('/admin/order/offlinePayment', {

						orderCode: e
					})
					.then((res) => {
						this.dialogVisible = false
						this.getBill()
						this.$message({
							showClose: true,
							message: '恭喜你，确认成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
			},
			addok(e) {
				this.$axios
					.post('/admin/order/pickupDelivery', {
						orderCode: e
					})
					.then((res) => {
						this.dialogVisible = false
						this.getBill()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
			},
			handleChecked() {
				var i = 0
				this.shoplist.map((item, index) => {
					if (item.checked) {
						i = i + 1
					}
				})
				if (this.shoplist.length == i) {
					this.checkAll = true
				} else {
					this.checkAll = false
				}
			},
			refsend(e) {
				this.$alert('确定要给此订单退款吗？', '提示', {
					confirmButtonText: '确定',
					callback: action => {
						if (action == 'confirm') {
							this.$axios
								.post('/admin/order/confirmRefund', {
									orderCode: e,
								})
								.then((res) => {
									this.getBill()
								})
						}
					}
				});
			},
			getlogist(e, n) {
				var arrsd = []
				this.loglist.map((item, index) => {
					if (e == index) {

					} else {
						arrsd.push(item)
					}
				})
				this.loglist = arrsd
				n.logistics.map(items => {
					items.checked = false
					this.shoplist.push(items)
				})

			},

			getdel(e, d, n) {
				var arrs = []

				this.loglist[e].logistics.map((item, index) => {
					if (d == index) {

					} else {
						arrs.push(item)
					}
				})
				this.loglist[e].logistics = arrs
				n.checked = false
				this.shoplist.push(n)

			},
			getlost() {
				var obj = {
					logisticsTrackingNumber: '',
					logistics: [],
					orderStoreGoodsIds: []
				}
				this.loglist.push(obj)
			},
			geton() {
				var arr = []
				var ssd = []
				this.shoplist.map((item, index) => {
					if (item.checked) {
						arr.push(item)
					} else {
						ssd.push(item)
					}
				})
				this.shoplist = ssd
				this.loglist[this.chooid].logistics = [...this.loglist[this.chooid].logistics, ...arr]
				this.showbtn = false
			},
			handleCheckedCitiesChange(val) {
				console.log("4444", val, this.checkedCities)

			},
			handleCheckAllChange(val) {
				if (val) {
					this.shoplist.map((item, index) => {
						item.checked = true
					})
				} else {
					this.shoplist.map((item, index) => {
						item.checked = false
					})
				}
				this.isIndeterminate = false
			},
			addshop(e) {
				this.chooid = e
				this.checkAll = false
				var arrss = []
				this.loglist.map(item => {
					item.logistics.map((item, index) => {
						arrss.push(item.id)
					})
				})
				var lists = []
				this.shoplist.map((item, index) => {
					if (arrss.indexOf(item.id) != -1) {} else {
						lists.push(item)
					}
				})
				this.shoplist = lists
				console.log('777', this.shoplist)
				this.showbtn = true

			},
			getshop() {
				var that = this
				this.$axios
					.post('/sysOrder/getUnshippedItems', {
						orderId: that.id,
					})
					.then((res) => {
						console.log(2222222, res);
						res.data.map((item, index) => {
							item.checked = false
						})
						this.shoplist = res.data
					})

			},
			sures() {
				this.flag = true
				this.$axios
					.post('/admin/order/delivery', {
						logisticsTrackingNumber: this.logisticsTrackingNumber,
						orderCode: this.id,
						isUserSelfPickup: this.pickupNum
					})
					.then((res) => {
						console.log(res);
						this.dialogVisible = false
						this.logisticsTrackingNumber = ''
						this.getBill()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
						this.flag = false
					}).catch((err) => {
						this.flag = false
					})
			},
			getsch() {
				this.current = 1
				this.getBill()
			},
			getaglin() {
				this.searchForm = {
					phone: '',
					endTime: "",
					orderType: '',
					type: 0,
					name: "",
					orderCode: "",
					startTime: "",
				}
				this.tTime = null
				this.current = 1
				this.getBill()
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach((row) => {
						this.$refs.multipleTable.toggleRowSelection(row)
					})
				} else {
					this.$refs.multipleTable.clearSelection()
				}
			},
			handleSelectionChange(val) {
				this.multipleSelection = val
				this.delBtlStatu = val.length == 0
			},
			handleSizeChange(val) {
				console.log('6666', val)
				this.size = val
				this.getBill()
			},
			handleCurrentChange(val) {
				console.log('5555', val)
				this.current = val
				this.getBill()
			},
			handleSuccess(response, file, fileList) {
				if (response.code == 0) {
					this.$message({
						showClose: true,
						message: '恭喜你，导入成功',
						type: 'success',
						onClose: () => {
							this.getBill()
						},
					})
				} else {
					this.$message({
						type: 'warning',
						message: response.msg,
					})
				}
			},
			getInfo(billId) {
				this.BillDetailsvisible = true
				this.$nextTick(() => {
					this.$refs.BillDetails.init(billId)
				})
			},

			refund(id) {
				this.$confirm('此操作订单退款，是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					this.$axios
						.post('/admin/aftersale/refund', {
							orderLotteryId: id
						})
						.then((res) => {
							this.$message({
								showClose: true,
								message: '恭喜你，操作成功',
								type: 'success',
								onClose: () => {
									this.getBill()
								},
							})
						})
				})
			},

			// excel表上传
			handleChange(file, fileList) {
				this.fileTemp = file.raw
				let fileName = file.raw.name
				let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
				// 判断上传文件格式
				if (this.fileTemp) {
					if (fileType == 'xlsx' || fileType == 'xls') {
						this.importf(this.fileTemp)
					} else {
						this.$message({
							type: 'warning',
							message: '附件格式错误，请删除后重新上传！',
						})
					}
				} else {
					this.$message({
						type: 'warning',
						message: '请上传附件！',
					})
				}
			},

			//获取资讯列表
			getBill() {
				if (this.tTime == null) {
					this.searchForm.startTime = ''
					this.searchForm.endTime = ''
				} else {
					this.searchForm.startTime = this.tTime[0]
					this.searchForm.endTime = this.tTime[1]
				}
				this.searchForm.pageNo = this.current
				this.searchForm.pageSize = this.size
				this.$axios.post('/admin/order/getOrderList', this.searchForm)
					.then((res) => {
						console.log(2222222222, res);
						this.tableData = res.data.records
						this.size = res.data.size
						this.current = res.data.current
						this.total = res.data.total
					})
			},
			getshows(e) {
				this.outListId = e
				this.showTime = true
			},
			getdwon() {
				if (this.stop == false) {
					this.stop = true
				} else {
					return
				}
				var that = this
				if (this.outListId == 1) {
					if (that.outTime == null || that.outTime.length == 0) {
						var startTime = ''
						var endTime = ''
					} else {
						var startTime = that.outTime[0]
						var endTime = that.outTime[1]
					}
					setTimeout(function() {
						this.stop = false
					}, 3000)


					axios({
						method: 'get',
						url: ty.apiurl + '/admin/order/exportOrder?endTime=' + endTime + '&startTime=' + startTime,
						headers: {
							'Content-Type': 'application/json; charset=utf-8',
							'Authorization': localStorage.getItem('token')
						},
						responseType: 'blob'
					}).then((res) => {
						console.log('7474', res.data)
						const link = document.createElement('a')
						let blob = new Blob([res.data], {
							type: 'application/vnd.ms-excel'
						})
						link.style.display = 'none'
						link.href = URL.createObjectURL(blob);
						link.setAttribute('download', '订单列表.xlsx');
						link.click();
						link = null;
						that.outTime = true
						that.showTime = false
						that.stop = false
					}).catch(error => {
						that.showTime = false
					})

				} else {
					if (that.outTime == null || that.outTime.length == 0) {
						var startTime = ''
						var endTime = ''
					} else {
						var startTime = that.outTime[0]
						var endTime = that.outTime[1]
					}
					setTimeout(function() {
						this.stop = false
					}, 3000)


					axios({
						method: 'get',
						url: ty.apiurl + '/admin/order/exportOrderDetail?endTime=' + endTime + '&startTime=' +
							startTime,
						headers: {
							'Content-Type': 'application/json; charset=utf-8',
							'Authorization': localStorage.getItem('token')
						},
						responseType: 'blob'
					}).then((res) => {
						console.log('7474', res.data)
						const link = document.createElement('a')
						let blob = new Blob([res.data], {
							type: 'application/vnd.ms-excel'
						})
						link.style.display = 'none'
						link.href = URL.createObjectURL(blob);
						link.setAttribute('download', '订单列表.xlsx');
						link.click();
						link = null;
						that.outTime = true
						that.showTime = false
						that.stop = false
					}).catch(error => {
						that.showTime = false
					})

				}




				// var that =this
				// that.$axios
				// 	.get('/sysOrder/export', {
				// 		params:that.searchForm
				// 	},responseType: 'blob'),
				// 	.then((res) => {
				// 		const link = document.createElement('a')
				// 		        let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
				// 		        link.style.display = 'none'
				// 		        link.href = URL.createObjectURL(blob)

				// 		        // link.download = res.headers['content-disposition'] //下载后文件名
				// 		        link.download = data.fileName //下载的文件名
				// 		        document.body.appendChild(link)
				// 		        link.click()
				// 		        document.body.removeChild(link)
				// 	})

			},
			getexcelist() {
				var that = this
				let option = {} //option代表的就是excel文件
				var tableHeader = [
					'用户名',
					'订单号',
					'下单时间',

					'收货时间',
					'订单金额',
					'实付金额',
					'订单状态',
				]
				// var tableWith = [
				// 	'10',
				// 	'4',
				// 	'15',
				// 	'7',
				// 	'7',
				// 	'6',
				// 	'6',
				// 	'7',
				// 	'7',
				// 	'6',
				// 	'6',
				// 	'20',
				// 	'8',
				// 	'10',
				// 	'12',
				// 	'12',
				// 	'15',
				// 	'5',
				// 	'9',
				// 	'9',
				// 	'9',
				// 	'12',
				// ]
				let dataTable = [] //   dataTable代表excel文件中的数据内容
				if (that.dataList) {
					for (let i in that.dataList) {
						let obj = {
							用户名: that.dataList[i].nickName,
							订单号: that.dataList[i].orderNumber,
							下单时间: that.dataList[i].createTime,

							收货时间: that.dataList[i].completionTime,
							订单金额: that.dataList[i].money,
							实付金额: that.dataList[i].paymentAmount,
							订单状态: that.dataList[i].orderState == 1 ? '待配送' : that.dataList[i].orderState == 2 ?
								'配送中' : that.dataList[i].orderState == 8 ? '已发货' : that.dataList[i]
								.orderState == 3 ? '已完成' : that.dataList[i].orderState == 4 ? '售后申请' : that
								.dataList[i].orderState == 5 ? '退款成功' : that.dataList[i].orderState == 7 ?
								'取消订单' : '',

						}
						dataTable.push(obj) //   设置excel每列获取的数据源
					}
				}

				option.fileName = '订单信息' //excel文件名
				//excel文件数据
				option.datas = [{
					//   excel文件的数据源
					sheetData: dataTable,
					//   excel文件sheet的表名
					sheetName: '订单信息',
					//   excel文件表头名
					sheetHeader: tableHeader,
					//   excel文件列名
					sheetFilter: tableHeader,
					// columnWidths: tableWith,
				}, ]
				//   创建ExportJsonExcel实例对象
				let toExcel = new ExportJsonExcel(option, 'sss')
				//   调用保存方法
				toExcel.saveExcel()
				that.loading = false
			},
			exporBilltExcel() {
				var that = this
				that.loading = true
				if (that.tTime == null) {
					that.searchForm.startTime = ''
					that.searchForm.endTime = ''
				} else {
					that.searchForm.startTime = that.tTime[0]
					that.searchForm.endTime = that.tTime[1]
				}
				that.pagedwon = that.pagedwon + 1
				that.searchForm.pageNo = that.pagedwon


				that.searchForm.pageSize = that.size
				that.$axios
					.post('/sysOrder/getOrderList', that.searchForm)
					.then((res) => {
						if (res.data.records.length > 0) {
							that.dataList = [...that.dataList, ...res.data.records]
							setTimeout(function() {
								that.exporBilltExcel()
							}, 100)

						} else {
							that.getexcelist()
						}


					})
			},
			addsend(e) {
				this.logisticsTrackingNumber = ''
				var that = this
				that.dialogVisible = true
				that.id = e

			},
			//商品已到货
			arrived(billId) {
				this.$axios
					.post('/sysOrder/distribution', {
						id: billId
					})
					.then((res) => {
						this.getBill()
						this.$message({
							showClose: true,
							message: '恭喜你，操作成功',
							type: 'success',
							onClose: () => {

							},
						})
					})
			},


		},
	}
</script>

<style scoped>
	.el-button {
		padding: 0 10px;
		height: 35px;
		line-height: 35px;
		font-size: 15px;
		margin-right: 10px;
	}

	.btnnexts {
		width: 336px;
		height: 48px;
		background: #4293FE;
		border-radius: 24px;
		text-align: center;
		line-height: 48px;
		color: #ffffff;
		margin: 0 auto 20px;
	}

	.flexjcen {
		display: flex;
		justify-content: space-between;
	}

	.flexcen {
		display: flex;
		align-items: center;
		margin-bottom: 20px;

	}

	.bline {
		margin: 10px auto;

	}

	.bgimg {
		width: 100px;
		height: 100px;
		display: block;
		margin-left: 20px;
		margin-right: 20px;
		border-radius: 10px;
	}

	.crile {
		border: 1px solid #cccccc;
		border-radius: 50%;
		width: 24px;
		height: 24px;
		box-sizing: border-box;
	}

	.crilebule {
		border-radius: 50%;
		width: 24px;
		height: 24px;
		background: #4293FE;
	}

	.namediscount {
		font-size: 16px;
		margin: 10px 0px;
	}
</style>